import React from 'react';
import KeysOutlineIcon from './keys_outline';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function CompletionIcon(props) {
  return ___EmotionJSX(KeysOutlineIcon, props);
}